document.addEventListener('DOMContentLoaded', () => {
	const button = document.querySelector('.back-to-top');
	if (!button) {
		return;
	}

	const offset = Math.max(0, parseInt(button.getAttribute('data-offset'), 10) || 400);
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	let ticking = false;

	const updateVisibility = () => {
		const y = window.scrollY || document.documentElement.scrollTop || 0;
		button.classList.toggle('is-visible', y > offset);
	};

	const onScroll = () => {
		if (ticking) {
			return;
		}
		ticking = true;
		window.requestAnimationFrame(() => {
			updateVisibility();
			ticking = false;
		});
	};

	button.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: reduceMotion ? 'auto' : 'smooth',
		});
	});

	window.addEventListener('scroll', onScroll, { passive: true });
	updateVisibility();
});
